import type { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http'
import { inject } from '@angular/core'
import { ToastrService } from 'ngx-toastr'
import { catchError, throwError } from 'rxjs'

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
    const toastrService = inject(ToastrService)

    const handleError = (errorResponse: HttpErrorResponse) => {
        const error = errorResponse.error
        if (!error) {
            toastrService.error(errorResponse.message ?? 'Произошла ошибка')
            return
        }

        if (error?.errors) {
            const err = error.errors

            switch (true) {
                case Array.isArray(err):
                    err.forEach((e) => {
                        if (typeof e === 'object' && e !== null) {
                            Object.keys(e).forEach((k) => {
                                toastrService.error(k)
                            })
                            return
                        }
                        toastrService.error(e)
                    })
                    break
                case typeof err === 'object' && err !== null:
                    if (err.message) {
                        toastrService.error(err.message)
                        return
                    }
                    Object.keys(err).forEach((k) => {
                        toastrService.error(k)
                    })
                    break
                default:
                    toastrService.error(
                        typeof err === 'string' ? err : 'Произошла ошибка'
                    )
            }
            return
        }

        if (error.message) {
            toastrService.error(error.message)
        }
    }

    return next(req).pipe(
        catchError((err: HttpErrorResponse) => {
            handleError(err)
            return throwError(() => err)
        })
    )
}
